import { GenIcon } from '../helpers/IconBase.es.js';

const MarkAsReadAlternativeOutlined = (props) => {
    return GenIcon({
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M2.25 5.5C2.25 5.08579 2.58579 4.75 3 4.75H21C21.4142 4.75 21.75 5.08579 21.75 5.5C21.75 5.91421 21.4142 6.25 21 6.25H3C2.58579 6.25 2.25 5.91421 2.25 5.5ZM21.0658 13.2625C21.3587 13.5553 21.3587 14.0302 21.0658 14.3231L16.8232 18.5658C16.5303 18.8586 16.0554 18.8586 15.7625 18.5658L12.9341 15.7373C12.6412 15.4444 12.6412 14.9696 12.9341 14.6767C13.227 14.3838 13.7019 14.3838 13.9948 14.6767L16.2929 16.9748L20.0052 13.2625C20.2981 12.9696 20.773 12.9696 21.0658 13.2625ZM3 8.75C2.58579 8.75 2.25 9.08579 2.25 9.5C2.25 9.91421 2.58579 10.25 3 10.25H21C21.4142 10.25 21.75 9.91421 21.75 9.5C21.75 9.08579 21.4142 8.75 21 8.75H3ZM2.25 13.5C2.25 13.0858 2.58579 12.75 3 12.75H8C8.41421 12.75 8.75 13.0858 8.75 13.5C8.75 13.9142 8.41421 14.25 8 14.25H3C2.58579 14.25 2.25 13.9142 2.25 13.5ZM3 16.75C2.58579 16.75 2.25 17.0858 2.25 17.5C2.25 17.9142 2.58579 18.25 3 18.25H8C8.41421 18.25 8.75 17.9142 8.75 17.5C8.75 17.0858 8.41421 16.75 8 16.75H3Z',
                    fill: '#82869E',
                },
            },
        ],
    })(props);
};

export { MarkAsReadAlternativeOutlined };
